// 消息类型枚举
export const msgType = {
  labelSelection: 1, // 标签
  text: 2, // 文本
  image: 3, // 图片
  video: 4, // 视频
  file: 5, // 文件
  review: 6, // 评价
  assignAgent: 7, // 客服分配
  addConversation: 8, // 添加会话
  deleteConversation: 9, // 删除会话
  userOnline: 10, // 用户上线
  userOffline: 11, // 用户下线
  editMsg: 12, // 修改消息
  delMsg: 13, // 删除消息
  readMsg: 14, // 已读消息
  typeKfOnline: 15, // 客服上线
  typeKfOffline: 16, // 客服下线
  messageTypeKfBusy: 17, // 客服忙碌
  messageTypeRemoteLogin: 18, // 账号被登录
  messageTypeUnReadMsg: 19, // 标记未读
};
// 在线状态枚举
export const onlineStatus = {
  offline: 0, // 离线
  online: 1, // 在线
  busy: 2, // 忙碌
};
